import { motion } from 'framer-motion';
import T from 'prop-types';
import React from 'react';

import Text from '@skippay/core/components/Text';
import { be, bm } from '@skippay/core/utils/classUtils';

import { ReactComponent as CloseIconMobile } from 'assets/icons/close-small.svg';
import { ReactComponent as IconSuccess } from 'assets/icons/icon-check-circle-small.svg';
import { ReactComponent as IconError } from 'assets/icons/warning.svg';

import './index.sass';

const MODULE_NAME = 'NotificationBox';

function NotificationBox(props) {
	const { title, children, error = false, success = false, warning = false, onClose } = props;

	return (
		<motion.div
			initial={{ opacity: 0, y: -40 }}
			animate={{ opacity: 1, y: 0 }}
			className={bm(MODULE_NAME, { error, success, warning })}
		>
			{(error || success) && (
				<span className={be(MODULE_NAME, 'icon')}>
					{error && <IconError />}
					{success && <IconSuccess />}
				</span>
			)}
			{title && (
				<Text as="strong" className={be(MODULE_NAME, 'title')}>
					{title}
				</Text>
			)}
			{children && <div className={be(MODULE_NAME, 'content')}>{children}</div>}
			{!!onClose && (
				<div onClick={onClose} className={be(MODULE_NAME, 'close')} role="button">
					<CloseIconMobile />
				</div>
			)}
		</motion.div>
	);
}

NotificationBox.propTypes = {
	error: T.bool,
	onClose: T.func,
	success: T.bool,
	title: T.node.isRequired,
	warning: T.bool,
};

export default NotificationBox;
